import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';
import i18n from 'i18next';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = theme => ({
    buttonsGrid: {
        display: 'flex',
        height: '80px',
        '& > *': {
            margin: theme.spacing(0)
        },
    },
    button: {
        minWidth: '50px',
        minHeight: '42px'
    },
    icon: {
        fontSize: '30px'
    }
});

// Proper SVG based CSV icon
function CsvIcon(props) {
    return (
        <SvgIcon viewBox="0 0 115.28 122.88" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M25.38,57h64.88V37.34H69.59c-2.17,0-5.19-1.17-6.62-2.6c-1.43-1.43-2.3-4.01-2.3-6.17V7.64l0,0H8.15 c-0.18,0-0.32,0.09-0.41,0.18C7.59,7.92,7.55,8.05,7.55,8.24v106.45c0,0.14,0.09,0.32,0.18,0.41c0.09,0.14,0.28,0.18,0.41,0.18 c22.78,0,58.09,0,81.51,0c0.18,0,0.17-0.09,0.27-0.18c0.14-0.09,0.33-0.28,0.33-0.41v-11.16H25.38c-4.14,0-7.56-3.4-7.56-7.56 V64.55C17.82,60.4,21.22,57,25.38,57L25.38,57z M45.88,82.35l6.29,1.9c-0.42,1.76-1.09,3.24-2,4.42c-0.91,1.18-2.03,2.08-3.38,2.68 c-1.35,0.6-3.06,0.9-5.14,0.9c-2.53,0-4.59-0.37-6.19-1.1c-1.6-0.74-2.98-2.03-4.14-3.87c-1.16-1.84-1.75-4.21-1.75-7.09 c0-3.84,1.02-6.79,3.06-8.85c2.05-2.06,4.94-3.09,8.68-3.09c2.92,0,5.23,0.59,6.9,1.77c1.67,1.18,2.92,3,3.73,5.45l-6.32,1.4 c-0.22-0.7-0.45-1.22-0.7-1.54c-0.41-0.55-0.9-0.97-1.48-1.26c-0.58-0.3-1.23-0.44-1.95-0.44c-1.63,0-2.88,0.65-3.75,1.96 c-0.65,0.97-0.98,2.49-0.98,4.56c0,2.57,0.39,4.33,1.17,5.29c0.78,0.95,1.88,1.43,3.3,1.43c1.37,0,2.41-0.38,3.11-1.16 C45.06,84.93,45.56,83.82,45.88,82.35L45.88,82.35z M54.47,84.17l6.81-0.43c0.15,1.1,0.45,1.95,0.9,2.52 c0.74,0.94,1.79,1.41,3.17,1.41c1.02,0,1.81-0.24,2.36-0.72c0.56-0.48,0.83-1.04,0.83-1.67c0-0.6-0.26-1.14-0.78-1.62 c-0.52-0.48-1.75-0.92-3.66-1.35c-3.15-0.7-5.38-1.64-6.72-2.82c-1.35-1.17-2.03-2.66-2.03-4.48c0-1.19,0.35-2.31,1.04-3.37 c0.69-1.06,1.73-1.9,3.12-2.5c1.39-0.61,3.29-0.91,5.71-0.91c2.97,0,5.23,0.55,6.78,1.66c1.56,1.1,2.48,2.86,2.78,5.27l-6.75,0.4 c-0.18-1.05-0.56-1.82-1.13-2.3c-0.58-0.48-1.37-0.72-2.38-0.72c-0.83,0-1.46,0.18-1.89,0.53c-0.42,0.35-0.63,0.78-0.63,1.29 c0,0.37,0.17,0.7,0.51,0.99c0.33,0.31,1.13,0.59,2.39,0.85c3.14,0.68,5.38,1.36,6.73,2.05c1.36,0.69,2.35,1.55,2.96,2.57 c0.62,1.02,0.92,2.17,0.92,3.44c0,1.49-0.41,2.86-1.23,4.12c-0.83,1.25-1.97,2.21-3.45,2.86c-1.48,0.65-3.34,0.97-5.58,0.97 c-3.95,0-6.68-0.76-8.2-2.28C55.53,88.44,54.67,86.51,54.47,84.17L54.47,84.17z M76.91,68.63h7.5l5.23,16.71l5.16-16.71h7.28 l-8.62,23.22h-7.77L76.91,68.63L76.91,68.63z M97.79,57h9.93c4.16,0,7.56,3.41,7.56,7.56v31.42c0,4.15-3.41,7.56-7.56,7.56h-9.93 v13.55c0,1.61-0.65,3.04-1.7,4.1c-1.06,1.06-2.49,1.7-4.1,1.7c-29.44,0-56.59,0-86.18,0c-1.61,0-3.04-0.64-4.1-1.7 c-1.06-1.06-1.7-2.49-1.7-4.1V5.85c0-1.61,0.65-3.04,1.7-4.1c1.06-1.06,2.53-1.7,4.1-1.7h58.72C64.66,0,64.8,0,64.94,0 c0.64,0,1.29,0.28,1.75,0.69h0.09c0.09,0.05,0.14,0.09,0.23,0.18l29.99,30.36c0.51,0.51,0.88,1.2,0.88,1.98 c0,0.23-0.05,0.41-0.09,0.65V57L97.79,57z M67.52,27.97V8.94l21.43,21.7H70.19c-0.74,0-1.38-0.32-1.89-0.78 C67.84,29.4,67.52,28.71,67.52,27.97L67.52,27.97z"/>
        </SvgIcon>
    );
}

// Proper SVG based PDF icon
function PdfIcon(props) {
    return (
        <SvgIcon viewBox="0 0 115.28 122.88" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M25.38,57h64.88V37.34H69.59c-2.17,0-5.19-1.17-6.62-2.6c-1.43-1.43-2.3-4.01-2.3-6.17V7.64l0,0H8.15 c-0.18,0-0.32,0.09-0.41,0.18C7.59,7.92,7.55,8.05,7.55,8.24v106.45c0,0.14,0.09,0.32,0.18,0.41c0.09,0.14,0.28,0.18,0.41,0.18 c22.78,0,58.09,0,81.51,0c0.18,0,0.17-0.09,0.27-0.18c0.14-0.09,0.33-0.28,0.33-0.41v-11.16H25.38c-4.14,0-7.56-3.4-7.56-7.56 V64.55C17.82,60.4,21.22,57,25.38,57L25.38,57z M29.5,67.4h13.19c2.87,0,5.02,0.68,6.46,2.05c1.43,1.37,2.14,3.31,2.14,5.84 c0,2.59-0.78,4.62-2.34,6.08c-1.56,1.46-3.94,2.19-7.14,2.19h-4.35v9.49H29.5V67.4L29.5,67.4z M37.45,78.37h1.95 c1.54,0,2.62-0.27,3.24-0.8c0.62-0.53,0.93-1.21,0.93-2.04c0-0.81-0.27-1.49-0.81-2.05c-0.54-0.56-1.55-0.84-3.05-0.84h-2.27V78.37 L37.45,78.37z M54.99,67.4h11.78c2.32,0,4.2,0.32,5.63,0.94c1.43,0.63,2.61,1.53,3.55,2.71c0.93,1.18,1.61,2.55,2.02,4.11 c0.42,1.56,0.63,3.22,0.63,4.97c0,2.74-0.31,4.87-0.94,6.38c-0.62,1.51-1.49,2.78-2.6,3.8c-1.11,1.02-2.3,1.7-3.57,2.04 c-1.74,0.47-3.31,0.7-4.72,0.7H54.99V67.4L54.99,67.4z M62.9,73.21v14.01h1.95c1.66,0,2.84-0.19,3.55-0.55 c0.7-0.37,1.25-1.01,1.65-1.92c0.4-0.92,0.6-2.4,0.6-4.45c0-2.72-0.44-4.57-1.33-5.58c-0.89-1-2.36-1.5-4.42-1.5H62.9L62.9,73.21z M82.25,67.4h19.6v5.52H90.21v4.48h9.96v5.2h-9.96v10.46h-7.95V67.4L82.25,67.4z M97.79,57h9.93c4.16,0,7.56,3.41,7.56,7.56v31.42 c0,4.15-3.41,7.56-7.56,7.56h-9.93v13.55c0,1.61-0.65,3.04-1.7,4.1c-1.06,1.06-2.49,1.7-4.1,1.7c-29.44,0-56.59,0-86.18,0 c-1.61,0-3.04-0.64-4.1-1.7c-1.06-1.06-1.7-2.49-1.7-4.1V5.85c0-1.61,0.65-3.04,1.7-4.1c1.06-1.06,2.53-1.7,4.1-1.7h58.72 C64.66,0,64.8,0,64.94,0c0.64,0,1.29,0.28,1.75,0.69h0.09c0.09,0.05,0.14,0.09,0.23,0.18l29.99,30.36c0.51,0.51,0.88,1.2,0.88,1.98 c0,0.23-0.05,0.41-0.09,0.65V57L97.79,57z M67.52,27.97V8.94l21.43,21.7H70.19c-0.74,0-1.38-0.32-1.89-0.78 C67.84,29.4,67.52,28.71,67.52,27.97L67.52,27.97z"/>
        </SvgIcon>
    );
}

/**
 * Export Buttons
 */
class ExportButtons extends Component {

    /**
     * HANDLER FOR BUTTON CLICKS
     */

    handleButtonClick( event, type, customData ) {
        event.stopPropagation();

        if( type === "csv" ) {
            if( null != this.props.onCsvClick ) {
                this.props.onCsvClick( customData );
            }

        } else if( type === "pdf" ) {
            if( null != this.props.onPdfClick ) {
                this.props.onPdfClick( customData );
            }

        } else if( type === "print" ) {
            if( null != this.props.onPrintClick ) {
                this.props.onPrintClick( customData );
            }
        }
    }

    // Generate the necessary button
    generateButton( type, buttonProps ) {
        let button = "";

        /**
         * buttonProps contains:
         *      showIcon := [true|false]
         *      showText := [true|false]
         *      text := <string>
         *      tooltip := <string>
         *      customData := custom data structure to be submitted on button click
         */

        // Already grab the icon for later use
        let icon = "";
        if( type === "csv" ) {
            icon = (<CsvIcon className={this.props.classes.icon} />);
        } else if( type === "pdf" ) {
            icon = (<PdfIcon className={this.props.classes.icon} />);            
        } else if( type === "print" ) {
            icon = (<PrintIcon className={this.props.classes.icon} />);
        }

        // Prep default texts and tooltips
        let text = "";
        if( type === "csv" ) {
            text = i18n.t("export.buttons.csv");
        } else if( type === "pdf" ) {
            text = i18n.t("export.buttons.pdf");
        } else if( type === "print" ) {
            text = i18n.t("export.buttons.print");
        }

        if( null != buttonProps.text ) {
            text = buttonProps.text;
        }

        let tooltip = "";
        if( type === "csv" ) {
            tooltip = i18n.t("export.tooltips.csv");
        } else if( type === "pdf" ) {
            tooltip = i18n.t("export.tooltips.pdf");
        } else if( type === "print" ) {
            tooltip = i18n.t("export.tooltips.print");
        }

        if( null != buttonProps.tooltip ) {
            tooltip = buttonProps.tooltip;
        }

        // Generate the proper button
        if( true === buttonProps.showIcon ) {
            if( true === buttonProps.showText ) {

                // Show Icon and Text
                button = (
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        startIcon={icon}
                        title={tooltip}
                        onClick={(event) => this.handleButtonClick(event, type, buttonProps.customData)}
                    >
                        {text}
                    </Button>
                )

            } else {

                // Show Icon only
                button = (
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        title={tooltip}
                        onClick={(event) => this.handleButtonClick(event, type, buttonProps.customData)}
                    >
                        {icon}
                    </Button>
                )
            }
        } else {
            if( true === buttonProps.showText ) {

                // Show Text only
                button = (
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        title={tooltip}
                        onClick={(event) => this.handleButtonClick(event, type, buttonProps.customData)}
                    >
                        {text}
                    </Button>
                )

            } else {

                // Show nothing? Okay, if you say so
                button = (
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        title={tooltip}
                        onClick={(event) => this.handleButtonClick(event, type, buttonProps.customData)}
                    />
                )
            } 
        }

        return button;
    }

    /**
     * RENDER
     */
    render() {

        // This class offers CSV, PDF and Print Buttons
        // Depending on given props the class shows multiple of these buttons
        // For each button the props can define:
        // * Type of button: CSV, PDF, Print
        // * If the button has an additional text aside of the icon or not
        // * If the button has a tooltip and if yes which text to show on the tooltip
        // * Custom data to be sent back to the parent class if button has been pressed
        // Certain fallback tooltips and button texts are defined if none are specified

        let allButtons = [];

        // Generate all CSV buttons depending on input props
        if( null != this.props.csvButtons ) {
            for( let i = 0; i < this.props.csvButtons.length; i++ ) {
                const button = this.generateButton( "csv", this.props.csvButtons[i] );
                allButtons.push( button );
            }
        }

        // Generate all PDF buttons depending on input props
        if( null != this.props.pdfButtons ) {
            for( let i = 0; i < this.props.pdfButtons.length; i++ ) {
                const button = this.generateButton( "pdf", this.props.pdfButtons[i] );
                allButtons.push( button );
            }
        }

        // Generate all Print buttons depending on input props
        if( null != this.props.printButtons ) {
            for( let i = 0; i < this.props.printButtons.length; i++ ) {
                const button = this.generateButton( "print", this.props.printButtons[i] );
                allButtons.push( button );
            }
        }

        return (
            <Grid container direction="row" className={this.props.classes.buttonsGrid} spacing={1} justify="flex-end">
                {allButtons.map((button, i) => {
                    return (
                        <Grid item key={"export-buttons-"+i}>
                            {button}
                        </Grid>
                    )
                })}
            </Grid>
        );
    }
};

export default withStyles(useStyles)(ExportButtons);